import { IconDirective } from '../../directives/icon.directive';

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconMapping } from '../../constants/icon-mappings';
import { BehaviorSubject } from 'rxjs';
/**
 * Binary icon component. This component is responsible for showing a binary button with icons.
 *
 * @param {{icons: [{ iconName: string; id: string }, { iconName: string; id: string }];iconMappings: IconMapping;}} iconProperties 
 * The two icons that will be displayed with their iconName and id, and iconMappings. 
 * fullScreenIconMappings = {
      iconMappings: {
        'diagram-nested': {
          mainIcon: 'diagram-nested',
          mainIcon_transform: 'grow-8',
        },
        sort: {
          mainIcon: 'sort',
          mainIcon_transform: 'grow-8',
        },
      },
      icons: [
        { iconName: 'diagram-nested', id: '0' },
        {
          iconName: 'sort',
          id: '1',
        },
      ],
    };
  *
  * @param {BehaviorSubject<string | null>} selectedbuttonId$ Emits the id of the clicked button.
  * 
 */
@Component({
  selector: 'app-binary-button',
  standalone: true,
  imports: [CommonModule, IconDirective],
  templateUrl: './binary-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BinaryButtonComponent {
  iconProperties = input<{
    icons: [{ iconName: string; id: any }, { iconName: string; id: any }];
    iconMappings: IconMapping;
  }>();

  selectedbuttonId$ = input<BehaviorSubject<any | null>>();

  onClickBinaryButton(id: any) {
    this.selectedbuttonId$().next(id);
  }
}
